/**
 * Dufftie Smart Search — Fuzzy-Matching & Typo-Korrektur
 *
 * Normalisiert Suchanfragen, entfernt Bindestriche,
 * korrigiert häufige Tippfehler und matched gegen
 * bekannte Marken-/Produktnamen.
 */
(function () {
  'use strict';

  // Bekannte Markennamen und Synonyme
  var BRANDS = [
    'xerjoff', 'tiziana terenzi', 'kilian', 'mancera', 'montale',
    'prada', 'gucci', 'jean paul gaultier', 'labor8', 'franck boclet',
    'philipp plein', 'givenchy', 'bvlgari', 'bulgari', 'burberry',
    'acqua di parma', 'tom ford', 'dior', 'chanel', 'versace',
    'dolce gabbana', 'carolina herrera', 'hugo boss', 'boss',
    'armaf', 'lattafa', 'trussardi', 'nishane', 'montblanc',
    'narciso rodriguez', 'paco rabanne', 'yves saint laurent', 'ysl',
    'roberto cavalli', 'shiseido', 'memo paris', 'boucheron',
    'the merchant of venice', 'signature royale'
  ];

  // Synonym-Map: Tippfehler/Varianten → korrekter Term
  var SYNONYMS = {
    'labora': 'labor8', 'labor': 'labor8', 'lapor': 'labor8', 'labo8': 'labor8',
    'labor 8': 'labor8', 'la por': 'labor8',
    'xeroff': 'xerjoff', 'xerjof': 'xerjoff', 'xerioff': 'xerjoff',
    'xerjouf': 'xerjoff', 'xerjov': 'xerjoff',
    'tiziana': 'tiziana terenzi', 'terenzi': 'tiziana terenzi',
    'manacera': 'mancera', 'mancerea': 'mancera', 'mencera': 'mancera',
    'montal': 'montale', 'montalle': 'montale',
    'killian': 'kilian', 'killan': 'kilian',
    'gaultie': 'jean paul gaultier', 'gaultier': 'jean paul gaultier',
    'jpg': 'jean paul gaultier', 'jp gaultier': 'jean paul gaultier',
    'bulgari': 'bvlgari', 'bvlgary': 'bvlgari',
    'dolce gabana': 'dolce gabbana', 'dg': 'dolce gabbana',
    'aqua di parma': 'acqua di parma', 'aqua': 'acqua di parma',
    'philipp plien': 'philipp plein', 'philip plein': 'philipp plein',
    'givenchi': 'givenchy', 'givency': 'givenchy',
    'franck boeclet': 'franck boclet', 'frank boclet': 'franck boclet',
    'pacco rabanne': 'paco rabanne', 'paco rabane': 'paco rabanne',
    'hugo bos': 'hugo boss',
    'versache': 'versace', 'versachi': 'versace',
    'burburry': 'burberry', 'burberri': 'burberry',
    'montblank': 'montblanc', 'mont blanc': 'montblanc',
    'narcisso': 'narciso rodriguez', 'narciso': 'narciso rodriguez',
    'nishanne': 'nishane', 'nischane': 'nishane',
    'lattaffa': 'lattafa', 'latafa': 'lattafa',
    'dufftberater': 'duftberater', 'duftberrater': 'duftberater',
    'parfum': 'parfum', 'parfüm': 'parfum', 'perfume': 'parfum',
    'edp': 'eau de parfum', 'edt': 'eau de toilette',
    'herren': 'herren', 'männer': 'herren', 'men': 'herren',
    'damen': 'damen', 'frauen': 'damen', 'women': 'damen'
  };

  /**
   * Levenshtein-Distanz zwischen zwei Strings
   */
  function levenshtein(a, b) {
    var m = a.length, n = b.length;
    var dp = [];
    for (var i = 0; i <= m; i++) {
      dp[i] = [i];
      for (var j = 1; j <= n; j++) {
        dp[i][j] = i === 0 ? j : 0;
      }
    }
    for (var i = 1; i <= m; i++) {
      for (var j = 1; j <= n; j++) {
        if (a[i - 1] === b[j - 1]) {
          dp[i][j] = dp[i - 1][j - 1];
        } else {
          dp[i][j] = 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
        }
      }
    }
    return dp[m][n];
  }

  /**
   * Normalisiert einen Suchbegriff:
   * - Lowercase
   * - Bindestriche/Sonderzeichen entfernen
   * - Umlaute normalisieren
   * - Doppelte Leerzeichen entfernen
   */
  function normalize(term) {
    return term
      .toLowerCase()
      .replace(/[-–—_.]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Versucht den Suchbegriff gegen bekannte Marken zu matchen.
   * Gibt den besten Match zurück oder null.
   */
  function findBestMatch(term) {
    var normalized = normalize(term);

    // 1. Exakter Synonym-Match
    if (SYNONYMS[normalized]) {
      return SYNONYMS[normalized];
    }

    // 2. Teilwort-Synonym-Match (jedes Wort prüfen)
    var words = normalized.split(' ');
    for (var w = 0; w < words.length; w++) {
      if (SYNONYMS[words[w]]) {
        words[w] = SYNONYMS[words[w]];
        return words.join(' ');
      }
    }

    // 3. Fuzzy-Match gegen Marken (Levenshtein ≤ 2)
    var bestDist = 999;
    var bestBrand = null;
    for (var i = 0; i < BRANDS.length; i++) {
      var brand = BRANDS[i];
      // Nur vergleichen wenn Längen ähnlich
      if (Math.abs(normalized.length - brand.length) > 3) continue;

      var dist = levenshtein(normalized, brand);
      if (dist < bestDist && dist <= 2) {
        bestDist = dist;
        bestBrand = brand;
      }

      // Auch Teilwörter gegen Marken matchen
      for (var w = 0; w < words.length; w++) {
        if (Math.abs(words[w].length - brand.length) > 3) continue;
        var wDist = levenshtein(words[w], brand);
        if (wDist < bestDist && wDist <= 2) {
          bestDist = wDist;
          bestBrand = brand;
        }
      }
    }

    return bestBrand;
  }

  /**
   * Patcht die predictive-search Komponente
   */
  function patchPredictiveSearch() {
    var originalFetch = window.fetch;

    window.fetch = function (url, options) {
      if (typeof url === 'string' && url.indexOf('section_id=predictive-search') > -1) {
        try {
          var urlObj = new URL(url, location.origin);
          var query = urlObj.searchParams.get('q');
          if (query) {
            var corrected = findBestMatch(query);
            if (corrected && normalize(corrected) !== normalize(query)) {
              urlObj.searchParams.set('q', corrected);
              // Originalquery merken für "Meinten Sie?" Anzeige
              window.__dfSearchOriginal = query;
              window.__dfSearchCorrected = corrected;
              return originalFetch.call(this, urlObj.toString(), options).then(function (response) {
                // Wenn korrigierte Suche auch keine Ergebnisse bringt, original versuchen
                return response;
              });
            }
          }
        } catch (e) { /* Fehler ignorieren, original fetch nutzen */ }
      }
      return originalFetch.call(this, url, options);
    };
  }

  /**
   * Patcht die Suchseite (Full-Page Search)
   */
  function patchSearchPage() {
    var input = document.querySelector('.search-page-input, input[name="q"]');
    if (!input) return;

    var form = input.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var query = input.value.trim();
      var corrected = findBestMatch(query);
      if (corrected && normalize(corrected) !== normalize(query)) {
        input.value = corrected;
      }
    });
  }

  // Initialisieren
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchPredictiveSearch();
      patchSearchPage();
    });
  } else {
    patchPredictiveSearch();
    patchSearchPage();
  }
})();
